import React from "react";
import Page from "../../Components/Page";
import { styled, Typography } from "@mui/material";
import zarmlogo from "../../images/zarm_logo.png";

const StyledZARMLogo = styled('img')({
    width: "128px",
    maxWidth: "100%",
    marginBottom: "16px"
});

export default function Imprint() {
    return (
        <Page padding title="Imprint">
            <StyledZARMLogo src={zarmlogo} alt="ZARM logo" />
            <Typography>
                Legal notice for the 30th ELGRA Symposium 2027 – www.elgra2027.org
            </Typography>
            <br />
            <Typography variant="h6">
                ZARM, Center of Applied Space Technology and Microgravity
            </Typography>
            <Typography>
                Am Fallturm 2, D-28359 Bremen, Germany
                <br />
                Directors: Prof. Dr. Marc Avila and Prof. Dr. Katharina Brinkert
                <br />
                Phone: 0421 218-57 827
                <br />
                E-Mail: info@zarm.uni-bremen.de
                <br />
                Internet: www.zarm.uni-bremen.de
                <br />
                VAT ID: DE 811 245 070
                <br />
                Public corporation of the University of Bremen, chaired by
                Rector Prof. Dr. Jutta Günther
                <br />
                Supervisory authority: Bremen's Senator's Office for
                Environment, Climate and Science, An der Reeperbahn 2, 28217
                Bremen
            </Typography>
            <br />
            <Typography variant="h6">
                ZARM Fallturm-Betriebsgesellschaft mbH (ZARM FAB mbH)
            </Typography>
            <Typography>
                c/o University of Bremen, Am Fallturm 2, D-28359 Bremen, Germany
                <br />
                Management: Prof. Dr. Marc Avila, Peter von Kampen
                <br />
                Phone: 0421-218-57 817
                <br />
                E-Mail: office@zarm.uni-bremen.de
                <br />
                Commercial Register No. HRB 12 600, District Court Bremen
                <br />
                VAT ID: DE 114 437 671
            </Typography>
            <br />
            <Typography variant="h6">Liability disclaimer</Typography>
            <Typography>
                ZARM assumes no responsibility for the topicality, correctness
                or completeness of the information provided. Liability claims
                are excluded unless ZARM demonstrates intentional or gross
                negligence. ZARM reserves the right to modify or discontinue
                content without notice. ZARM has no influence on the design and
                content of external websites and distances itself from the
                contents of all linked external pages.
            </Typography>
            <br />
            <Typography variant="h6">Copyright</Typography>
            <Typography>
                The online documents and websites, including their parts, are
                protected by copyright. Reproduction of content requires prior
                permission from ZARM unless otherwise stated.
            </Typography>
        </Page>
    );
}
